<template>
  <div id="app" class="main">
    <Navbar />
    <div class="viewport">
      <transition
              name="fade"
              mode="out-in"
      >
        <router-view></router-view>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
import Footer from "./components/Footer"

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  metaInfo: {
    meta: [
      { charset: 'utf-8' },
      { name: "description", content: "Garten- und Landschaftsbau Unternehmen aus Wächtersbach"},
      { name: 'keywords', content: 'garten, gartenpflege, winterdienst, baggerarbeiten, mähen, pflanzen, pflege, terassenbau, kehren, sturmschäden, teamwork'}
    ]
  }
}
</script>

<style lang="scss">
  @import 'assets/styles/index.scss';
  @import url('https://fonts.googleapis.com/css2?family=Rozha%20One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
</style>
